<div class="gallery-container theme-light">
  <div class="gallery-container__filters">
    <app-gallery-filters-loft *appFlagInternal></app-gallery-filters-loft>
    <app-gallery-filters-studio *appFlagExternal></app-gallery-filters-studio>
  </div>

  <div class="gallery-container__controls">
    <app-gallery-controls></app-gallery-controls>
  </div>

  <div class="gallery-container__body">
    <app-gallery-results
      [viewMode]="viewMode"
      [loading]="loading"
      [checkable]="checkable"
      [showActions]="showActions"
      [selectLabel]="selectLabel"
      [results]="results"
      [checkedResults]="checkedResults"
      [galleryActionsTemplate]="galleryActionsTemplate"
      [galleryTagsTemplate]="galleryTagsTemplate"
      (selectBookmark)="handleSelect($event)">
    </app-gallery-results>
  </div>
</div>